import { Box } from "@mui/material";

export const AppleStyleSpinner = () => {
  return (
    <Box
      sx={{
        width: "16px",
        height: "16px",
        position: "relative",
        display: "inline-block",
        "& > div": {
          position: "absolute",
          width: "10%",
          height: "26%",
          backgroundColor: "currentColor",
          left: "49%",
          top: "43%",
          opacity: 0,
          borderRadius: "50px",
          animation: "fade 1s linear infinite",
        },
        "& > div:nth-of-type(1)": {
          transform: "rotate(0deg) translate(0, -130%)",
          animationDelay: "-0.916s",
        },
        "& > div:nth-of-type(2)": {
          transform: "rotate(30deg) translate(0, -130%)",
          animationDelay: "-0.833s",
        },
        "& > div:nth-of-type(3)": {
          transform: "rotate(60deg) translate(0, -130%)",
          animationDelay: "-0.75s",
        },
        "& > div:nth-of-type(4)": {
          transform: "rotate(90deg) translate(0, -130%)",
          animationDelay: "-0.666s",
        },
        "& > div:nth-of-type(5)": {
          transform: "rotate(120deg) translate(0, -130%)",
          animationDelay: "-0.583s",
        },
        "& > div:nth-of-type(6)": {
          transform: "rotate(150deg) translate(0, -130%)",
          animationDelay: "-0.5s",
        },
        "& > div:nth-of-type(7)": {
          transform: "rotate(180deg) translate(0, -130%)",
          animationDelay: "-0.416s",
        },
        "& > div:nth-of-type(8)": {
          transform: "rotate(210deg) translate(0, -130%)",
          animationDelay: "-0.333s",
        },
        "& > div:nth-of-type(9)": {
          transform: "rotate(240deg) translate(0, -130%)",
          animationDelay: "-0.25s",
        },
        "& > div:nth-of-type(10)": {
          transform: "rotate(270deg) translate(0, -130%)",
          animationDelay: "-0.166s",
        },
        "& > div:nth-of-type(11)": {
          transform: "rotate(300deg) translate(0, -130%)",
          animationDelay: "-0.083s",
        },
        "& > div:nth-of-type(12)": {
          transform: "rotate(330deg) translate(0, -130%)",
          animationDelay: "0s",
        },
        "@keyframes fade": {
          from: { opacity: 1 },
          to: { opacity: 0.25 },
        },
      }}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </Box>
  );
};
